import { Box, keyframes, Stack, styled } from '@mui/system';
import { FC } from 'react';
import AktifyChatIcon from './aktify-chat-icon.svg';

const ChatMessage = styled(Stack)`
  display: flex;
  align-items: center;
  min-width: 60%;
  max-width: 100%;
  gap: 8px;

  &.left {
    align-self: flex-start;
    flex-direction: row;
  }
`;

const ChatBubble = styled('div')<{
  sender: 'Inbound' | 'Outbound';
}>`
  border-radius: 10px;
  max-width: 80%;
  position: relative;
  padding: 10px;
  background-color: ${({ sender }) => (sender === 'Inbound' ? 'white' : '#318adc')};
  color: ${({ sender }) => (sender === 'Inbound' ? '#2e2e2e' : '#fff')};
`;

const AvatarContainer = styled(Box)`
  display: flex;
  align-items: center;
`;

const AktifyIcon = styled(Box)(() => ({
  height: 40,
  width: 40,
  backgroundImage: `url(${AktifyChatIcon})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
}));

const blink = keyframes`
  0% { opacity: 0.2; }
  100% { opacity: 1; }
`;

const BlinkingDot: FC<{ offsetTime: string }> = ({ offsetTime }) => (
  <Box
    sx={{
      width: 6,
      height: 6,
      borderRadius: '50%',
      bgcolor: '#fff',
      animation: `${blink} 1s infinite alternate ${offsetTime}`,
    }}
  />
);

export const ChatTypingLoader = () => (
  <Stack spacing={0.5}>
    <ChatMessage className="left">
      <AvatarContainer>
        <AktifyIcon />
      </AvatarContainer>
      <ChatBubble sender="Outbound">
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <BlinkingDot offsetTime="0.0s" />
          <BlinkingDot offsetTime="0.2s" />
          <BlinkingDot offsetTime="0.4s" />
        </Box>
      </ChatBubble>
    </ChatMessage>
  </Stack>
);
